(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mx-editorial-filter"] && !Shopify.designMode) return;
  try {
    (() => {
  const instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    const nav = root.querySelector('[data-mx-filter-nav]');
    const results = root.querySelector('[data-mx-filter-results]');
    const status = root.querySelector('[data-mx-filter-status]');
    const errorBox = root.querySelector('[data-mx-filter-error]');
    if (!nav || !results || !status || !errorBox || !root.dataset.sectionId) return;
    const base = new URL(root.dataset.blogUrl, location.href);
    const basePath = base.pathname.replace(/\/$/, '');
    const initialPath = location.pathname;
    let displayedURL = new URL(location.href);
    let pending = null;
    let requestID = 0;
    let controller;
    const destination = href => {
      const url = new URL(href, location.href);
      if (url.origin !== location.origin) return null;
      if (url.pathname.replace(/\/$/, '') !== basePath && !url.pathname.startsWith(basePath + '/tagged/') && url.pathname !== initialPath) return null;
      url.searchParams.delete('section_id');
      url.searchParams.delete('sections');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url;
    };
    const identity = url => url.pathname + url.search;
    const resetPending = () => nav.querySelectorAll('[data-pending]').forEach(link => link.removeAttribute('data-pending'));
    nav.querySelectorAll('a').forEach(link => link.setAttribute('aria-controls', results.id));
    const more = nav.querySelector('[data-mx-tags-more]');
    const search = nav.querySelector('[data-mx-tags-search]');
    const tagList = nav.querySelector('[data-mx-tags-list]');
    const tagEmpty = nav.querySelector('[data-mx-tags-empty]');
    const fold = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const closeMore = (focusSummary = false) => {
      if (!more?.open) return;
      more.open = false;
      if (focusSummary) more.querySelector('summary').focus();
    };
    if (more) {
      more.addEventListener('toggle', () => { if (more.open && matchMedia('(min-width: 600px)').matches) search?.focus({ preventScroll: true }); });
      more.addEventListener('keydown', event => { if (event.key === 'Escape') closeMore(true); });
    }
    if (search && tagList) search.addEventListener('input', () => {
      const query = fold(search.value);
      let shown = 0;
      tagList.querySelectorAll('a').forEach(link => {
        const match = !query || fold(link.textContent).includes(query);
        link.hidden = !match;
        if (match) shown++;
      });
      if (tagEmpty) tagEmpty.hidden = shown > 0;
    });
    const outside = event => { if (more?.open && !more.contains(event.target)) closeMore(); };
    document.addEventListener('click', outside);
    async function update(url, mode = 'push', source = null) {
      const id = ++requestID;
      controller?.abort();
      controller = new AbortController();
      const currentController = controller;
      const previousURL = displayedURL;
      const retryHadFocus = errorBox.contains(document.activeElement);
      pending = { url, mode };
      errorBox.hidden = true;
      status.textContent = '';
      results.setAttribute('aria-busy', 'true');
      results.classList.remove('mx-filter-enter');
      resetPending();
      if (source && nav.contains(source)) source.setAttribute('data-pending', 'true');
      const loadingTimer = setTimeout(() => {
        if (id === requestID) status.textContent = root.dataset.loadingMessage;
      }, 250);
      const timeout = setTimeout(() => currentController.abort(), 15000);
      try {
        const requestURL = new URL(url);
        if (requestURL.pathname === initialPath && !requestURL.pathname.startsWith(basePath)) requestURL.pathname = basePath;
        requestURL.hash = '';
        requestURL.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(requestURL, { signal: currentController.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Section unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (id !== requestID) return;
        const nextRoot = [...doc.querySelectorAll('[data-mx-filter]')].find(node => node.dataset.sectionId === root.dataset.sectionId);
        const nextResults = nextRoot?.querySelector('[data-mx-filter-results]');
        const nextNav = nextRoot?.querySelector('[data-mx-filter-nav]');
        const currentSlot = nav.querySelector('[data-mx-filter-current]');
        const nextSlot = nextNav?.querySelector('[data-mx-filter-current]');
        if (!nextResults || !nextNav) throw new Error('Incomplete section');
        nextResults.querySelectorAll('script').forEach(script => script.remove());
        const selected = [...nextNav.querySelectorAll('a[aria-current]')].map(link => new URL(link.getAttribute('href'), url).pathname);
        const focusResults = results.contains(document.activeElement) || errorBox.contains(document.activeElement) || (retryHadFocus && document.activeElement === document.body);
        if (mode === 'push' && identity(url) !== identity(displayedURL)) history.pushState(history.state, '', url);
        if (mode === 'replace') history.replaceState(history.state, '', url);
        results.replaceChildren(...nextResults.childNodes);
        if (currentSlot && nextSlot) {
          currentSlot.replaceChildren(...nextSlot.childNodes);
          currentSlot.querySelectorAll('a').forEach(link => link.setAttribute('aria-controls', results.id));
        }
        nav.querySelectorAll('a').forEach(link => {
          if (selected.includes(new URL(link.href).pathname)) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });
        displayedURL = url;
        pending = null;
        errorBox.hidden = true;
        status.textContent = root.dataset.resultsMessage.replace('__COUNT__', String(results.querySelectorAll('.mx-card').length));
        results.classList.add('mx-filter-enter');
        if (focusResults) results.focus({ preventScroll: true });
      } catch (error) {
        if (id !== requestID) return;
        if (mode === 'pop') {
          history.replaceState(history.state, '', previousURL);
          pending.mode = 'replace';
        }
        status.textContent = '';
        errorBox.hidden = false;
      } finally {
        clearTimeout(timeout);
        clearTimeout(loadingTimer);
        if (id === requestID) {
          results.setAttribute('aria-busy', 'false');
          resetPending();
        }
      }
    }
    const click = event => {
      const retry = event.target.closest('[data-mx-filter-retry]');
      if (retry && root.contains(retry) && pending) {
        update(pending.url, pending.mode);
        return;
      }
      const link = event.target.closest('[data-mx-filter-nav] a, [data-mx-filter-pagination] a');
      if (!link || !root.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
      const url = destination(link.href);
      if (!url) return;
      event.preventDefault();
      if (more?.contains(link)) closeMore();
      if (identity(url) === identity(displayedURL)) {
        if (pending) {
          requestID++;
          controller?.abort();
          pending = null;
          results.setAttribute('aria-busy', 'false');
          errorBox.hidden = true;
          status.textContent = '';
          resetPending();
        }
        return;
      }
      update(url, 'push', link);
    };
    const pop = () => {
      const url = destination(location.href);
      if (url) update(url, 'pop');
    };
    root.addEventListener('click', click);
    window.addEventListener('popstate', pop);
    instances.set(root, () => {
      requestID++;
      controller?.abort();
      root.removeEventListener('click', click);
      window.removeEventListener('popstate', pop);
      document.removeEventListener('click', outside);
      instances.delete(root);
    });
  }
  const initAll = () => document.querySelectorAll('[data-mx-filter]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, dispose] of instances) if (event.target === root || event.target.contains(root)) dispose();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-stories"] && !Shopify.designMode) return;
  try {
    class ProductStories extends HTMLElement {
    constructor() {
      super();
      this.videos = this.querySelectorAll(".product-story");
      this.videos.forEach((video) =>
        video.addEventListener("click", () => {
          this.showPiP(video.dataset.index);
        })
      );
    }

    createForm() {
      const form = document.createElement("form");
      form.setAttribute("action", "/cart/add");
      form.setAttribute("method", "POST");
      form.setAttribute("data-product-id", window.product.id);
      form.setAttribute("enctype", "multipart/form-data");

      const inputId = document.createElement("input");
      inputId.setAttribute("type", "hidden");
      inputId.setAttribute("name", "id");
      inputId.setAttribute("value", window.product.variantId);

      const inputQt = document.createElement("input");
      inputQt.setAttribute("type", "hidden");
      inputQt.setAttribute("name", "quantity");
      inputQt.setAttribute("value", 1);

      const button = document.createElement("button");
      button.setAttribute("id", "gallery-product-add-to-cart-" + window.product.id);
      button.setAttribute("type", "submit");
      button.setAttribute("name", "add");
      button.setAttribute("data-btn-addtocart", "");
      button.setAttribute("data-available", window.product.available);
      button.classList = "product-form__submit button button--primary button--pip-form";
      button.insertAdjacentHTML(
        "beforeend",
        `
          <svg role="presentation" stroke-width="1.5" focusable="false" width="22" height="22" class="icon icon-cart  m-lr-auto w-h-24" viewBox="0 0 22 22">
            <path d="M11 7H3.577A2 2 0 0 0 1.64 9.497l2.051 8A2 2 0 0 0 5.63 19H16.37a2 2 0 0 0 1.937-1.503l2.052-8A2 2 0 0 0 18.422 7H11Zm0 0V1" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          ${window.product.available == "true" ? '<span class="btn-tooltip">Adicionar</span>' : '<span class="btn-tooltip">Esgotado</span>'}
        `
      );
      if (window.product.available != "true") {
        button.setAttribute("disabled", "disabled");
      }

      form.appendChild(inputId);
      form.appendChild(inputQt);
      form.appendChild(button);

      return form;
    }

    showPiP(activeIndex) {
      document.querySelector(".pip-gallery")?.remove();
      document.body.insertAdjacentHTML(
        "beforeend",
        `
<div class="pip-gallery is-mute expanded">
  <div class="pip-gallery--wrapper">
    <button class="close-pip-gallery"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"/></svg></button>
    <div class="pip-gallery--navigation">
      <button class="navigate navigate-up" aria-label="Ver vídeo de cima">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon icon-up">
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
        </svg>
      </button>
      <button class="navigate navigate-down" aria-label="Ver vídeo de baixo">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon icon-down">
          <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
        </svg>
      </button>
    </div>
    <button aria-label="Mudo/Som" class="pip-gallery--mute">
      <span class="mute">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 24 24" 
          fill="currentColor" 
          class="icon icon-mute" 
        >
          <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM17.78 9.22a.75.75 0 1 0-1.06 1.06L18.44 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L20.56 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z" />
        </svg>
      </span>
      <span class="unmute">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 24 24" 
          fill="currentColor" 
          class="icon icon-unmute"
        >
          <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM18.584 5.106a.75.75 0 0 1 1.06 0c3.808 3.807 3.808 9.98 0 13.788a.75.75 0 0 1-1.06-1.06 8.25 8.25 0 0 0 0-11.668.75.75 0 0 1 0-1.06Z" />
          <path d="M15.932 7.757a.75.75 0 0 1 1.061 0 6 6 0 0 1 0 8.486.75.75 0 0 1-1.06-1.061 4.5 4.5 0 0 0 0-6.364.75.75 0 0 1 0-1.06Z" />
        </svg>
      </span>
    </button>
    <div class="pip-gallery-carousel">
    </div>
  </div>
</div>
      `
      );

      const gallery = document.querySelector(".pip-gallery");
      const carousel = document.querySelector(".pip-gallery-carousel");
      this.videos.forEach((video, index) => {
        const controlsWrapper = document.createElement("div");
        controlsWrapper.classList.add("controls-wrapper");

        const shareBtn = document.createElement("a");
        shareBtn.setAttribute("target", "_blank");
        shareBtn.setAttribute("aria-label", "Compartilhar");
        shareBtn.setAttribute(
          "href",
          `http://wa.me/?text=Veja este produto que encontrei na Maxfem: ${window.product.title.replaceAll("&", "E").replaceAll("(", "").replaceAll(")", "")} - ${window.product.url}`
        );
        shareBtn.classList = "video-share";
        shareBtn.insertAdjacentHTML(
          "beforeend",
          `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="icon icon-send">
    <path d="M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z" />
  </svg>`
        );
        shareBtn.insertAdjacentHTML("beforeend", `<span class="btn-tooltip">Compartilhar</span>`);

        const form = this.createForm();

        controlsWrapper.appendChild(shareBtn);
        controlsWrapper.appendChild(form);

        const videoWrapper = document.createElement("div");
        videoWrapper.classList.add("video-wrapper");

        const videoEl = video.querySelector("video").cloneNode(true);

        const playBtn = document.createElement("button");
        playBtn.classList.add("play-wrapper");
        playBtn.insertAdjacentHTML(
          "beforeend",
          `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="icon icon-play">
  <path fill-rule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z" clip-rule="evenodd"></path>
</svg> 
        `
        );

        playBtn.addEventListener("click", function (e) {
          if (window.innerWidth > 1024 || (window.innerWidth <= 1024 && gallery.classList.contains("expanded"))) {
            videoWrapper.classList.toggle("playing");
            if (videoEl.paused) {
              videoEl.play();
            } else {
              videoEl.pause();
            }
          }
        });

        videoWrapper.appendChild(videoEl);
        videoWrapper.appendChild(controlsWrapper);
        videoWrapper.appendChild(playBtn);

        carousel.appendChild(videoWrapper);

        if (index == activeIndex) {
          videoWrapper.classList.add("playing");
          videoWrapper.classList.add("current");
          videoEl.play();
          videoEl.muted = true;
        }
      });

      const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
      carousel.setAttribute("data-current-index", activeIndex);
      carousel.setAttribute("data-max-index", this.videos.length - 1);
      carousel.style.transform = `translateY(-${activeIndex * videoHeight}px)`;

      const mute = document.querySelector(".pip-gallery .pip-gallery--mute");
      const navUp = document.querySelector(".pip-gallery .navigate-up");
      const navDown = document.querySelector(".pip-gallery .navigate-down");

      mute.addEventListener("click", function (e) {
        gallery.classList.toggle("is-mute");
        const currVideo = carousel.querySelector(".video-wrapper.current");
        currVideo.querySelector("video").muted = gallery.classList.contains("is-mute");
      });

      navUp.addEventListener("click", function (e) {
        e.preventDefault();
        const currIndex = carousel.dataset.currentIndex;
        const maxIndex = carousel.dataset.maxIndex;

        if (currIndex === "0") return;

        const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
        const currVideo = carousel.querySelector(".video-wrapper.current");
        currVideo.classList.remove("playing");
        currVideo.classList.remove("current");
        currVideo.querySelector("video").pause();

        const nextVideo = currVideo.previousElementSibling;
        nextVideo.classList.add("playing");
        nextVideo.classList.add("current");
        nextVideo.querySelector("video").play();
        nextVideo.querySelector("video").muted = gallery.classList.contains("is-mute");

        const newIndex = currIndex - 1;
        carousel.style.transform = `translateY(-${newIndex * videoHeight}px)`;
        carousel.setAttribute("data-current-index", newIndex);

        if (newIndex == 0) navUp.setAttribute("disabled", "disabled");
        if (newIndex < maxIndex) navDown.removeAttribute("disabled");
      });

      navDown.addEventListener("click", function (e) {
        e.preventDefault();
        const currIndex = carousel.dataset.currentIndex;
        const maxIndex = carousel.dataset.maxIndex;

        if (currIndex === maxIndex) return;

        const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
        const currVideo = carousel.querySelector(".video-wrapper.current");
        currVideo.classList.remove("playing");
        currVideo.classList.remove("current");
        currVideo.querySelector("video").pause();

        const nextVideo = currVideo.nextElementSibling;
        nextVideo.classList.add("playing");
        nextVideo.classList.add("current");
        nextVideo.querySelector("video").play();
        nextVideo.querySelector("video").muted = gallery.classList.contains("is-mute");

        const newIndex = Number(currIndex) + 1;
        carousel.style.transform = `translateY(-${newIndex * videoHeight}px)`;
        carousel.setAttribute("data-current-index", newIndex);

        if (newIndex == maxIndex) navDown.setAttribute("disabled", "disabled");
        if (newIndex >= 1) navUp.removeAttribute("disabled");
      });

      let startX, startY, endX, endY;
      let isSwiping = false; // Flag to track if a swipe is in progress

      carousel.addEventListener("touchstart", function (e) {
        const touchStart = e.touches[0];
        startX = touchStart.clientX;
        startY = touchStart.clientY;
        isSwiping = false; // Reset the swipe flag
      });

      carousel.addEventListener("touchmove", function (e) {
        if (window.innerWidth <= 1024) {
          const touchMove = e.touches[0];
          endX = touchMove.clientX;
          endY = touchMove.clientY;

          const deltaY = endY - startY;

          if (Math.abs(deltaY) > Math.abs(endX - startX)) {
            isSwiping = true;
            e.preventDefault();
          }
        }
      });

      carousel.addEventListener("touchend", function (e) {
        if (window.innerWidth <= 1024) {
          if (gallery.classList.contains("expanded")) {
            const touchEnd = e.changedTouches[0];
            endX = touchEnd.clientX;
            endY = touchEnd.clientY;

            const deltaX = endX - startX;
            const deltaY = endY - startY;

            if (Math.abs(deltaX) < Math.abs(deltaY)) {
              if (deltaY > 25) {
                navUp.dispatchEvent(new Event("click"));
              } else if (deltaY < -25) {
                navDown.dispatchEvent(new Event("click"));
              }
            }
          }
        }
        isSwiping = false;
      });

      carousel.addEventListener("touchcancel", function () {
        isSwiping = false;
      });

      function shrinkGallery(event) {
        if (gallery.contains(event.target) || this.contains(event.target)) return;
        if (window.innerWidth <= 1024) {
          gallery.classList.remove("expanded");
        }
      }

      function debounce(fn, wait = 150, { leading = false } = {}) {
        let t,
          didLead = false;

        return (...args) => {
          const callNow = leading && !t && !didLead;
          clearTimeout(t);

          if (callNow) {
            didLead = true;
            fn(...args);
          }

          t = setTimeout(() => {
            t = null;
            didLead = false;
            if (!leading) fn(...args);
            else fn(...args); // trailing too
          }, wait);
        };
      }

      function recalculateGalleryPosition() {
        const currIndex = carousel.dataset.currentIndex;
        const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
        carousel.style.transform = `translateY(-${currIndex * videoHeight}px)`;
        carousel.setAttribute("data-current-index", currIndex);
      }

      const closeBtn = document.querySelector(".close-pip-gallery");
      closeBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        document.querySelector(".pip-gallery")?.remove();
        document.removeEventListener("click", shrinkGallery.bind(this));
      });

      gallery.addEventListener("click", function (e) {
        if (window.innerWidth <= 1024) {
          gallery.classList.add("expanded");
        }
      });

      gallery.querySelectorAll(".product-form__submit, .video-share").forEach((btn) => {
        btn.addEventListener("click", () => {
          const currVideo = carousel.querySelector(".video-wrapper.current");
          currVideo.classList.remove("playing");
          currVideo.querySelector("video").pause();
        });
      });

      document.addEventListener("click", shrinkGallery.bind(this));
      window.addEventListener(
        "resize",
        debounce(
          () => {
            recalculateGalleryPosition();
          },
          200,
          { leading: true }
        )
      );
    }
  }

  customElements.define("product-stories", ProductStories);
  document.addEventListener("DOMContentLoaded", function () {
    let storiesBtn = document.querySelectorAll("[data-open-stories]");

    storiesBtn.forEach((item) => {
      item.addEventListener("click", function () {});
    });
  });

  function isVisibleInViewport(element, offset = 0) {
    const elementStyle = window.getComputedStyle(element);
    //Particular cases when the element is not visible at all
    if (
      elementStyle.height == "0px" ||
      elementStyle.display == "none" ||
      elementStyle.opacity == "0" ||
      elementStyle.visibility == "hidden" ||
      elementStyle.clipPath == "circle(0px at 50% 50%)" ||
      elementStyle.transform == "scale(0)" ||
      element.hasAttribute("hidden")
    ) {
      return false;
    }

    const rect = element.getBoundingClientRect();

    const bottomDelimiter = parseInt(window.innerHeight || document.documentElement.clientHeight);
    const rightDelimiter = parseInt(window.innerWidth || document.documentElement.clientWidth);

    return (
      rect.top >= -1 * offset &&
      rect.left >= 0 &&
      rect.bottom <= bottomDelimiter + offset &&
      rect.right <= rightDelimiter
    );
  }

  function checkWrapperVisibility() {
    const storiesWrappers = document.querySelectorAll(".product-stories-wrapper");
    storiesWrappers.forEach((storiesWrapper) => {
      if (storiesWrapper) {
        const videos = storiesWrapper.querySelectorAll(".product-story-thumb video");

        if (isVisibleInViewport(storiesWrapper, 100)) {
          videos.forEach((video) => video.play());
        } else {
          videos.forEach((video) => video.pause());
        }
      }
    });
  }

  function debounce(func, timeout = 300) {
    let timer;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this);
      }, timeout);
    };
  }

  const events = ["resize", "scroll", "load"];

  for (let event of events) {
    window.addEventListener(event, debounce(checkWrapperVisibility));
  }

  document.addEventListener("DOMContentLoaded", function () {
    const scrollableContainers = document.querySelectorAll(".product-stories-inner");

    scrollableContainers.forEach((scrollableContainer) => {
      scrollableContainer.addEventListener("scroll", function (e) {
        const maxLeft = Math.max(0, scrollableContainer.scrollWidth - scrollableContainer.clientWidth);
        const scrollOffset = 10;

        scrollableContainer.parentElement.classList.toggle(
          "can-scroll-left",
          scrollableContainer.scrollLeft > scrollOffset
        );
        scrollableContainer.parentElement.classList.toggle(
          "can-scroll-right",
          scrollableContainer.scrollLeft < maxLeft - scrollOffset
        );
      });

      let isDragging = false;
      let startX;
      let scrollLeft;

      scrollableContainer.addEventListener("mousedown", function (e) {
        isDragging = true;
        startX = e.pageX - scrollableContainer.offsetLeft;
        scrollLeft = scrollableContainer.scrollLeft;
        scrollableContainer.style.cursor = "grabbing";
        scrollableContainer.style.userSelect = "none";
        e.preventDefault();
      });

      scrollableContainer.addEventListener("mousemove", function (e) {
        if (!isDragging) return;
        const x = e.pageX - scrollableContainer.offsetLeft;
        const walk = x - startX;
        scrollableContainer.scrollLeft = scrollLeft - walk;
      });

      function stopDragging() {
        isDragging = false;
        scrollableContainer.style.cursor = "";
        scrollableContainer.style.userSelect = "";
      }

      scrollableContainer.addEventListener("mouseup", stopDragging);
      scrollableContainer.addEventListener("mouseleave", stopDragging);

      scrollableContainer.dispatchEvent(new Event("scroll"));
    });
  });
  } catch(e) { console.error(e); }
})();

})();
